import * as React from 'react';
import { createElement } from 'react';
import { Button, Notification } from '@alifd/next';
import request from '@/utils/request';
import { workflowStore } from '@/store';
import { useLocalObservable, observer } from 'mobx-react';
const Save = observer((props) => {
    const { documentId } = useLocalObservable(() => workflowStore);
    const [loading, setLoading] = React.useState(false);
    const { formId, getFormValues, processType, opinionFormInstance, displayName, tabhelper } = props;
    const getComment = () => {
        return opinionFormInstance.getValues();
    };
    const getForm = () => {
        return getFormValues();
    };
    const save = async () => {
        setLoading(true);
        try {
            await request.post('/api/process/field/mapper/info', {
                formId,
                processType,
                formData: JSON.stringify(getForm()),
                comment: getComment(),
                bizDocListId: documentId,
            });
            Notification.success({
                title: '保存成功',
            });
            setLoading(false);
            tabhelper?.closeTab();
        }
        catch (error) {
            console.error(error);
            setLoading(false);
        }
    };
    return (createElement(Button, { onClick: save, loading: loading }, displayName));
});
export default Save;
